import { render, staticRenderFns } from "./IconPhone.vue?vue&type=template&id=45e23d28&scoped=true"
var script = {}
import style0 from "./IconPhone.vue?vue&type=style&index=0&id=45e23d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e23d28",
  null
  
)

export default component.exports